// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9468) return "static/chunks/9468-e0eb621af4ec45d4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6796":"7354acf255eb45d0","7188":"47bfd6ad5d731157"}[chunkId] + ".js";
};